import { useQuery } from '@tanstack/react-query';
import { getOutboundActivity, type OutboundGroup } from '../api/outbound';

export function useOutboundActivity(weeks: number, group: OutboundGroup | null = null) {
  return useQuery({
    queryKey: ['outbound', 'activity', weeks, group],
    queryFn: () => getOutboundActivity(weeks, group),
    refetchInterval: 300_000,
  });
}
